import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import useAdditionalCriteriaSelector from './hooks/useAdditionalCriteriaSelector/useAdditionalCriteriaSelector'
import * as Styles from './styles'

const AdditionalCriteriaSelector = ({ storeId, selectedCriterionIds, onChange, getCriteriaService, disabled }) => {
  const { t } = useTranslation()
  const { availabilityCriteria, loading } = useAdditionalCriteriaSelector({ storeId, getCriteriaService })

  const handleChange = e => onChange({ availability_criterion_ids: e.target.value })

  const menuItems = availabilityCriteria.map(criterion => ({
    value: criterion.id,
    label: `${criterion.internal_id} | ${criterion.name}`,
  }))

  return (
    <Styles.Container>
      <ComboBox
        multiple
        fullWidth
        label={t('Criterios adicionales')}
        value={selectedCriterionIds}
        handleChange={handleChange}
        menuItems={menuItems}
        helperText={t('Aplica criterios adicionales para limitar aún más la disponibilidad del método (opcional)')}
        loading={loading}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default AdditionalCriteriaSelector
